import { defineComponent } from '@vue/composition-api';
import { useGetLocalizedPath } from '@/util/globalHelpers';
export default defineComponent({
    props: {
        blok: {
            type: Object,
            default: null
        }
    },
    setup() {
        return { useGetLocalizedPath };
    }
});
